// components/Paginacion.js
import React from 'react';

export default function Paginacion({ currentPage, total, pageSize, onPageChange }) {

  const totalPages = Math.ceil(total / pageSize);
  const maxButtons = 5;
  const buttons = [];

  let startPage = Math.max(0, currentPage - Math.floor(maxButtons / 2));
  let endPage = Math.min(totalPages, startPage + maxButtons);

  if (endPage - startPage < maxButtons) {
    startPage = Math.max(0, endPage - maxButtons);
  }


  buttons.push(
    <button key="prev" className='prev-button' onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 0}>
      Anterior
    </button>
  );

  for (let i = startPage; i < endPage; i++) {
    buttons.push(
      <button key={i} onClick={() => onPageChange(i)} className={i === currentPage ? 'activo' : ''}>
        {i + 1}
      </button>
    );
  }

  buttons.push(
    <button key="next" className='next-button' onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages - 1}>
      Siguiente
    </button>
  );

  return (
    <div id="paginacion">
      {buttons}
    </div>
  );
}
